<div class="container-fluid">
  <div>
      <div class="header-container">
          <div class="page-header"><span class="fa fa-newspaper-o"></span>{{ 'bikeshop.posts.post' | translate }}</div>
          <div>
            <button pButton class="full-width" label="{{ 'bikeshop.posts.create_post' | translate }}" (click)="createPost()"></button>
          </div>
          <div class="loading" *ngIf="loading">
            <div class="loader"></div>
          </div>
        </div>

      <div class="card-container">
        <div *ngFor="let post of posts" class="post-card" (click)="editPost(post)">
          <!--<div class="card-image" [ngStyle]="{'background': post.postMedia && post. postMedia.length>0? 'url('+post.postMedia[0].mediaURL+')' : 'transparent', 'display': post.postMedia && post. postMedia.length>0 ? 'inherit' : 'none'}"></div>-->
          <div *ngIf="post.postMedia && post.postMedia.length > 0" style="position: relative;"><img style="width: 100%" src={{post.postMedia[0].mediaURL}}><div class="card-image-overlay"></div></div>
          <div *ngIf="post.postMedia && post.postMedia.length > 0" class="image-divider"></div>
          <div class="card-content">
              <div class="card-date">{{post.createdDate | date : 'dd MMM yyyy'}}</div>
              <div class="card-title">{{post.content}}</div>          
          </div>          
        </div>
      </div>
      <div *ngIf="!loading && posts.length===0" class="no-posts">          
        {{ 'bikeshop.posts.no_posts' | translate }}
      </div>

  </div>
</div>
